package org.moxultimate.topwithmox.architecture.ui

import androidx.compose.runtime.Immutable
import org.moxultimate.topwithmox.architecture.data.ArchitectureResponse

@Immutable
sealed class ArchitectureState {
    data object Loading : ArchitectureState()
    data class Error(val error : String) : ArchitectureState()
    data object Empty : ArchitectureState()
    data class Success(val architectureList: List<ArchitectureResponse>) : ArchitectureState()
    data class SuccessSingleData(val architecture: ArchitectureResponse) : ArchitectureState()
}